// eslint-disable-next-line import/no-anonymous-default-export
export default {
  setJson: (key, value) => (localStorage[key] = JSON.stringify(value)),
  getJSON: key => (localStorage[key] ? JSON.parse(localStorage[key]) : null),
  clear: () => localStorage.clear(),
};
